module.exports = "../dist/img/upper-banner-30.ac12.jpg";